import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
var axios_instance = get_axios_instance(api_variables.SERVICE_PAYROLL_PAYGROUPS);
var axios_instance_fetch_gross= get_axios_instance(api_variables.SERVICE_FETCH_GROSS_DETAILS)
var axios_instance_get_payroll_status= get_axios_instance(api_variables.SERVICE_GET_PAYROLL_STATUS)
var axios_instance_aduit= get_axios_instance(api_variables.SERVICE_ADUIT_LOG_DETAILS)
var axios_instance_insert= get_axios_instance(api_variables.SERVICE_INSERT_DETAILS)
var axios_instance_post_lock_actions=get_axios_instance(api_variables.SRVICE_POST_LOCK_ACTIONS)
var axios_instance_get_lock_actions=get_axios_instance(api_variables.SERVICE_GET_LOCK_ACTIONS)
var axios_instance_get_count_details=get_axios_instance(api_variables.SERVICE_GET_COUNT_DETAILS)
var axios_instance_patch_lock_actions=get_axios_instance(api_variables.SERVICE_PATCH_LOCK_ACTIONS)
var axios_instance_validation=get_axios_instance(api_variables.SERVICE_VALIDATION)
var axios_instance_get_validations=get_axios_instance(api_variables.SERVICE_GET_BEFORE_VALIDATION)
var axios_instance_exact_cycle=get_axios_instance(api_variables.SERVICE_EXACT_PAYCYCLE)
var axios_instance_rollBack_input=get_axios_instance(api_variables.SERVICE_ROLL_BACK)

const state = {
    data: [],
    isSelectedEmployees: {},
    employeeData: [],
    payGroups: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {

    set: (state, [payload, le_id]) => {        
        if (le_id) {
            state.payGroups[le_id] = payload;
            state.payGroups = {...state.payGroups };
        }
    },

    addPayGroups: (state, [payload, le_id]) => {
        if (le_id) {
            state.data[le_id] = payload;
            state.data = {...state.data };
            state.isSelectedEmployees = {...state.isSelectedEmployees}
        }
        // state.data.push(payload);
    },

    selectedEmployees: (state, [payload, le_id, isSelect]) => {
        if (le_id) {
            state.employeeData[le_id] = payload;
            state.employeeData = {...state.employeeData };
            state.isSelectedEmployees = {...state.isSelectedEmployees}
        }
        // state.data.push(payload);
    },

    clearSelectEmployees: (state, [le_id]) => {
        if (le_id) {
            state.employeeData[le_id].length = 0;
            state.employeeData = {...state.employeeData };
            state.isSelectedEmployees = {...state.isSelectedEmployees}
        }
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload.le_id,
                    processing_payroll_month: payload.processing_payroll_month,
                    financial_year: payload.financial_year,
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', [res.data.payload.data, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchdetailsgross({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_fetch_gross.get(`/`, {
                params: {
                    month: payload.month,
                    financial_year:payload.financial_year,
                    legal_entity_id:payload.legal_entity_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async getPayrollStatus({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_get_payroll_status.get(`/?`, {
                params: {
                    month: payload.month,
                    financial_year:payload.financial_year,
                    legal_entity_id:payload.legal_entity_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchdetailsAduit({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_aduit.get(``, {
                params: {
                    month: payload.month,
                    year:payload.year,
                    le_id:payload.le_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchdetailsLockActions({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_get_lock_actions.get(``, {
                params: {
                    month: payload.month,
                    year:payload.year,
                    le_id:payload.le_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchCountdetails({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_get_count_details.get(``, {
                params: {
                    payroll_month: payload.payroll_month,
                    financial_year:payload.financial_year,
                    le_id:payload.le_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchValidationDetails({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_validation.get(``, {
                params: {
                    month: payload.month,
                    year:payload.year,
                    le_id:payload.le_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchValidationDetailsBefore({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_get_validations.get(``, {
                params: {
                    month: payload.month,
                    year:payload.year,
                    le_id:payload.le_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchExactCycle({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_exact_cycle.get(``, {
                params: {
                    le_id:payload.le_id,
                }
            });
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchdetailsAduitInsert({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_insert.post(`?le_id=${payload.le_id}&year=${payload.year}&month=${payload.month}`);
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchdetailsLockActionsInsert({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_post_lock_actions.post(`?le_id=${payload.le_id}&year=${payload.year}&month=${payload.month}`);
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchrollBack({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_rollBack_input.post('',payload);
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async fetchdetailsLockActionsPatch({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_patch_lock_actions.patch(`?le_id=${payload.le_id}&year=${payload.year}&month=${payload.month}&payroll_lock_action_id=${payload.payroll_lock_action_id}&remarks=${payload.remarks}`);
            commit('setFetching', false);
            // if (res.status == 200) {
            //     commit('set', [res.data.payload.data, payload.le_id]);
            // }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    
    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            commit('setSaving', false);
            commit('addPayGroups', [payload.data, payload.le_id]);
            let res = { status: 200 };
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async selectEmployees({ commit }, payload) {
        try {
            commit('setSaving', true);
            commit('setSaving', false);
            commit('selectedEmployees', [payload.data, payload.le_id]);
            let res = { status: 200 };
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async clearSelectEmployees({ commit }, payload) {
        try {
            // commit('setSaving', true);
            // commit('setSaving', false);
            commit('clearSelectEmployees', [payload.le_id]);
            let res = { status: 200 };
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};